import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Typography, Button } from "@mui/material";

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 10, sm: 14 }, textAlign: "center" }}>
      <Typography variant="h1" sx={{ fontSize: { xs: "2.5rem", sm: "3.5rem" }, mb: 1.5 }}>{t("notFound.title")}</Typography>
      <Typography sx={{ mb: 4, color: "text.secondary" }}>{t("notFound.body")}</Typography>
      <Button variant="contained" size="large" onClick={() => navigate("/")}>{t("common.backHome")}</Button>
    </Container>
  );
}
